module.exports = __webpack_public_path__ + "img/107057.83a9084c.png";